import { render, staticRenderFns } from "./CrawledDocumentsTable.vue?vue&type=template&id=58b89b94&scoped=true"
import script from "./CrawledDocumentsTable.vue?vue&type=script&lang=js"
export * from "./CrawledDocumentsTable.vue?vue&type=script&lang=js"
import style0 from "./CrawledDocumentsTable.vue?vue&type=style&index=0&id=58b89b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b89b94",
  null
  
)

export default component.exports